// This file should only be used by the BroadcastService
// Notice, this is comparable to a set of rxjs BehaviorSubjects
// (https://rxjs.dev/api/index/class/BehaviorSubject) bound to
// Angular templates using an async pipe.
import { create } from 'zustand';
// Define the default values of the output.
// This is not exported on purpose to prevent misuse.
const useBroadcastOutput = create((_set) => ({
    serviceRunning: false,
    broadcasting: false,
    volume: 0,
    quality: 'sd',
    videoSize: { videoHeight: 0, videoWidth: 0 },
}));
// The rest of this file is AI-generated boilerplate, do not get intimidated
// by the length of the file.
// Reactive getters to be used in React
const reactiveOutput = {
    useServiceRunning: () => {
        return useBroadcastOutput((state) => state.serviceRunning);
    },
    useBroadcasting: () => {
        return useBroadcastOutput((state) => state.broadcasting);
    },
    useVolume: () => {
        return useBroadcastOutput((state) => state.volume);
    },
    useQuality: () => {
        return useBroadcastOutput((state) => state.quality);
    },
};
// This class should only be used by the BroadcastService
export class BroadcastServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setServiceRunning(serviceRunning) {
        useBroadcastOutput.setState({ serviceRunning });
    }
    setBroadcasting(broadcasting) {
        useBroadcastOutput.setState({ broadcasting });
    }
    setVolume(volume) {
        useBroadcastOutput.setState({ volume });
    }
    setQuality(quality) {
        useBroadcastOutput.setState({ quality });
    }
}
